import { useAuth } from '@shared/auth';

import { BasicAvatar } from '@/components/common/avatar/BasicAvatar';

export function UserDetails() {
  const { userId, givenName, familyName } = useAuth();
  const initials = givenName
    ? `${givenName.charAt(0)}${
        familyName?.charAt(0) ? familyName.charAt(0) : ''
      }`
    : userId?.substring(0, 2).toUpperCase() || 'TP';
  return (
    <BasicAvatar
      initials={initials}
      size="sm"
    />
  );
}
